import { Company } from "@/api/company-api";

export default function companyType(company: Company): string {
  const types: string[] = [];
  if (company.client) {
    types.push("発注者");
  }
  if (company.vendor) {
    types.push("協力業者");
  }
  return types.join("・");
}
